import { Menu, MenuProps } from "primereact/menu";
import { MenuItem, MenuItemOptions } from "primereact/menuitem";
import { isValidElement, ReactNode, RefObject } from "react";
import { NavLink } from "react-router-dom";

export function PrimeMenu({
  model,
  ref,
  ...rest
}: { ref: RefObject<Menu | null> } & MenuProps) {
  const items = model?.map(menuItemWithTemplate) || [];

  return <Menu ref={ref} model={items} {...rest} />;
}

function link(
  hasChildren: boolean,
  item: MenuItem,
  { className, labelClassName }: MenuItemOptions,
): ReactNode {
  return (
    <NavLink
      className={({ isActive }) =>
        `p-2 hover:bg-gray-100 flex gap-2${isActive ? "!bg-gray-100" : ""}${className ? ` ${className}` : ""}`
      }
      to={item.url || "#"}
    >
      {icon(item.icon)}
      {item.label && <label className={labelClassName}>{item.label}</label>}
      {hasChildren && <i className="pi pi-chevron-down" />}
    </NavLink>
  );
}

function icon(icon?: unknown): ReactNode {
  if (isValidElement(icon)) {
    return icon;
  } else if (typeof icon === "string") {
    return <i className={icon} />;
  }
}

function menuItemWithTemplate(menuItem: MenuItem): MenuItem {
  return {
    ...menuItem,
    template: (...rest) => link(!!menuItem.items, ...rest),
    ...(menuItem.items && { items: menuItem.items.map(menuItemWithTemplate) }),
  };
}
